<div class="container">
  <!-- Header -->
  <button
    class="float-right"
    mat-icon-button
    color="warn"
    (click)="closeDialog()"
  >
    <mat-icon svgIcon="close-circle"></mat-icon>
  </button>
  <h2 class="primary bold pb-3">
    <i class="fas fa-users"></i> {{ "groupal-inscription-title" | translate }}
  </h2>
  <p> {{ "groupal-inscription-legend" | translate }}<p>

  <p>
    {{ "not-refundable-groupal" | translate }} 
  </p>
  <div class="flex">
    <div class="pt-3"><h3 class="bold primary">{{ "information" | translate }}</h3></div>
    <p class="bold">{{ datos.name }}</p>
    <p>{{ datos.teacher_name }}</p>
    <p><strong>{{ "date" | translate }}:</strong> {{ datos.date | date : "dd/M/YYYY" }} - {{ datos.hour }} h.</p>
    <p><strong>{{ "price" | translate }}:</strong> {{ datos.price | currency : "EUR" : true }} <span class="small">{{ "commission-not-included" | translate }}</span></p>
  </div>
  <div class="flex">
    <form [formGroup]="payment_datos" class="pt-3">
      <div><h3 class="bold primary">{{ "payment-method" | translate }} </h3></div>
      
      <div>
        <input formControlName="payment_method" type="radio" name="payment_method" id="paypal" value="paypal"/>
        <img src="assets/img/paypal.png" class="pl-2" />
        <p class="small">{{ "paypal-commission" | translate }} </p>
      </div>
      <div class="pt-2">
        <input formControlName="payment_method" type="radio" name="payment_method" id="redsys" value="redsys"/>
        <mat-icon class="margin-right-05 pl-2" svgIcon="card"></mat-icon>
          {{ "payment-with-card" | translate }}
          <p class="small">{{ "redsys-commission" | translate }}</p>
      </div>
      <div class="mt-4 border-top pt-3">
        <input formControlName="conditions" type="checkbox"/> {{ "groupal-terms-conditions" | translate }} 
      </div>
      <button mat-raised-button color="primary" [disabled]="!validateform || loadingQuery" (click)="payGroupalClass()">{{ "pay" | translate }} </button>
    </form>
  </div>
</div>
